import React, { useState, useEffect } from "react";
import { MenuItem, FormControl, Select } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import BlueDownArrow from "../images/blueDownArrow.svg";
import BlueUpArrow from "../images/blueUpArrow.svg";

const useStyles = makeStyles({
  formControl: {
    width: "52px",
  },
  select: {
    width: "52px !important",
    height: "25px !important",
    fontSize: "14px !important",
    borderBottom: "1px solid #E1E1E1",
    marginBottom: "0px !important",
    "&:focus": {
      backgroundColor: "transparent",
    },
    "& .MuiSelect-select": {
      fontSize: "12px",
      fontWeight: "bold",
      paddingRight: "0px !important",
    },
    "& .MuiSelect-select:focus": {
      backgroundColor: "transparent",
    },
    "& .MuiInputBase-input": {
      padding: "0px !important", // FIX
    },
  },
  icon: {
    color: "#1a1a1a",
    right: "5px",
    position: "absolute",
    pointerEvents: "none",
  },
  menu: {
    marginTop: "5px",
  },
});

const EditorSelect = ({ options = [], value, onChange, disabled = false }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [orderedOptions, setOrderedOptions] = useState(options);

  useEffect(() => {
    if (!value) {
      setOrderedOptions(options);
      return;
    }

    const selected = options.find((opt) => opt.value === value);
    if (!selected) {
      setOrderedOptions(options);
      return;
    }

    const rest = options.filter((opt) => opt.value !== value);
    setOrderedOptions([selected, ...rest]);
  }, [options, value]);

  return (
    <div
      style={{ display: "flex", cursor: "pointer" }}
      onClick={() => setOpen(!open)}
    >
      <FormControl className={classes.formControl} disabled={disabled}>
        <Select
          variant="standard"
          value={value}
          onChange={onChange}
          open={open}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
          className={classes.select}
          disableUnderline
          MenuProps={{
            hideBackdrop: true,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            classes: {
              paper: classes.menu,
            },
            PaperProps: {
              style: {
                maxHeight: "128px",
                transform: "translateX(-12px)",
              },
            },
          }}
          IconComponent={() => null}
        >
          {orderedOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <img
        className="editorSelect"
        src={!open ? BlueDownArrow : BlueUpArrow}
        alt="Up"
      />
    </div>
  );
};

export default EditorSelect;
